import * as types from "../../mutation-types";
import {removeItem, addOrUpdateItem} from "../../helpers";

export default {
    [types.ADD_OR_UPDATE_TIMELOG]: (state, item) => addOrUpdateItem(state, item),
    [types.REMOVE_TIMELOG]: (state, item) => removeItem(state, item),
    [types.OPEN_GLOBAL_TIMELOG]: (state, {project_id, activity_type, activity_id, closable, isShort, autoFill}) => {
        state.globalTimelog.project_id = project_id
        state.globalTimelog.activity_type = activity_type
        state.globalTimelog.activity_id = activity_id
        state.globalTimelog.closable = closable === false ? false : true
        state.globalTimelog.isShort = isShort === false ? false : true
        state.globalTimelog.autoFill = autoFill === false ? false : true
        
        state.globalTimelog.active = true
    },
    [types.CLOSE_GLOBAL_TIMELOG]: (state) => state.globalTimelog.active = false,
}
